export default function () {}



// WEBPACK FOOTER //
// ./app/features/administration/lookups/tmLookupsDetailCtrl.js